import React, {Fragment, useEffect, useState} from 'react';
import {GoogleMap, InfoWindow, Marker, useJsApiLoader} from '@react-google-maps/api';
import {mostrarClienteById} from "../../redux/reducers/clientesReducer";
import * as signalR from "@microsoft/signalr";
import {HubConnection} from "@microsoft/signalr";

import {
    Alert,
    Backdrop,
    Divider,
    List,
    ListItem, ListItemButton,
    ListItemText,
    Snackbar,
    Theme,
    Typography,
    useMediaQuery
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Strings from "../../assets/strings";
import {getAgentes, getClientes} from "../../services";
import ContactDetails from "../clientes/ContactDetails";
import {useLocation, useNavigate} from "react-router-dom";
import {AppBar, ButtonResponsive, ListViewMode} from "../../components";
import {FilterList, Help} from "@mui/icons-material";
import {getLSLang, getUsuTipo, mapApiOptions, noTilde, TIPOUSUARIO} from "../../helpers";
import {getIcon} from "../../assets/iconPath";
import {getIdToken} from "../../services/auth";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IUser} from "../../redux/types/IUser";
import {IClienteSimple} from "../../redux/types/ICliente";
import {UseLoadScriptOptions} from "@react-google-maps/api/dist/useJsApiLoader";

const initialCenter = {
    lat: 0,
    lng: 0
};

const useStyles = makeStyles((theme:Theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        background: 'transparent',
    },
    searchBox:{
        top: "60px",
        right: "10px",
        width: "229px",
        maxHeight: "50%",
        position: "absolute",
        background: "white",
        overflow: "auto",
        zIndex: 1101,
        "&>div":{
            marginBottom: -10,
        },
        "& input":{
            padding: "10px 15px",
            width: "calc(100% - 4px)",
            boxSizing: "border-box",
            margin: "2px",
            border: "none",
            outline: "none",
            fontSize: "1em",
            background: "#eaeaea",
        }
    },
}));
function pinSymbol(proColor?:string,proIcon?:string): google.maps.Symbol  {
    let color = proColor ? proColor : "#b81717";
    let icon = proIcon ? proIcon : "Place";

    return {
        path:getIcon(icon)!,
        scale: 2, // > 1 to make it bigger
        fillColor: color, // Use RGBa function
       // background:color,
        fillOpacity: 1,
        strokeColor: 'hsl(0,0%,100%)', // Use HSLa function
        anchor: { x: 12, y: 24,equals:()=>true },
    };
}
function Map() {
    const { isLoaded } = useJsApiLoader({
        ...(mapApiOptions as UseLoadScriptOptions),
        language: getLSLang("l")
    })
    // const [map, setMap] = React.useState(null)
    //
    // const onLoad = React.useCallback(function callback(map:any) {
    //     // This is just an example of getting and using the map instance!!! don't just blindly copy!
    //     const bounds = new window.google.maps.LatLngBounds(center);
    //     map.fitBounds(bounds);
    //
    //     setMap(map)
    // }, [])
    //
    // const onUnmount = React.useCallback(function callback() {
    //     setMap(null)
    // }, [])





    const {id:usuId} = useAppSelector(state => state.auth.user ?? {})
    //const geolocation = useGeolocation()

    let navigate = useNavigate();
    let location = useLocation();
    const dispatch = useAppDispatch()
    const smVewport = useMediaQuery((theme:Theme) => theme.breakpoints.down('md'));

    const classes = useStyles();

    const [infoWin , setInfoWin ] = React.useState<string | null>(null);
    const [clientes, setClientes ] = React.useState<IClienteSimple[]>([]);
    const [clientesFilter, setClientesFilter ] = React.useState<IClienteSimple[]>([]);

    const [openFilter, setOpenFilter] = useState(false);
    const [snackbar, setSnackbar] = useState<string|null>(null);

    const [center, setCenter ] = React.useState<{lat:number,lng:number} | null>(null);
    const [allAgents, setAllAgents] = React.useState<IUser[]>([]);
    const [agentsCoor, setAgentsCoor] = React.useState<IUser[]>([]);
    const [currentPoint, setCurrentPoint ] = React.useState<{lat:number,lng:number} | null>(null);


    const [connectionRef, setConnection] = useState <HubConnection>();



    useEffect(() => {
        // if(getUsuTipo() === TIPOUSUARIO.titular || getUsuTipo() === TIPOUSUARIO.admin) {
            let hubConnection = new signalR.HubConnectionBuilder()
                .withUrl("https://api3.prestamistapp.net/hubs/map",{
                    accessTokenFactory: getIdToken as () => string
                })
                // .configureLogging(signalR.LogLevel.Information)
                .build();

            setConnection(hubConnection);
        // }
    }, [setConnection]);


    useEffect(() => {
        if (connectionRef?.state === "Disconnected") {

                connectionRef.on("ReceiveLocation", (id, lat, lng) => {
                    console.log(id, lat, lng)
                    setAgentsCoor(prevState => {
                        let estaAg = prevState.find(a=>a.id === id);
                        if(estaAg){
                            estaAg.coordenadasObj = {
                                lat,
                                lng
                            }
                            return [
                                ...(prevState.filter(a => a.id !== id)),
                                estaAg
                            ]
                        }
                        return prevState
                    });
                })

                // Starts the SignalR connection
                connectionRef.start().then(res => {
                    connectionRef.invoke("JoinGroup")
                        .catch(err => {
                            console.log(err);
                        });
                }).catch(err => {
                    console.log(err);
                })


        }

        return () => {
            if(connectionRef?.state === "Connected"){
                connectionRef.stop().then(()=> {
                    setConnection(undefined)
                });
            }
        };
    }, [usuId, setAgentsCoor, connectionRef,setConnection]);


    useEffect(()=>{
        if(getUsuTipo() === TIPOUSUARIO.titular || getUsuTipo() === TIPOUSUARIO.admin){
            getAgentes()
                .then(res=>{
                    let data:IUser[] = res?.data ?? [];

                    data = data.map((c)=>{
                        let coordenadas = undefined;
                        if(c.coordenadas && c.coordenadas.indexOf(",") !== -1){
                            let latLng = c.coordenadas.split(",");
                            coordenadas = {
                                lat: parseFloat(latLng[0]),
                                lng: parseFloat(latLng[1]),
                            };
                        }

                        return {...c,coordenadasObj:coordenadas}

                    })
                    setAllAgents(data);
                    setAgentsCoor(data.filter(a=>!!a.coordenadasObj))

                    //console.log(data)
                })
        }
        getClientes(undefined,true)
            .then(res=>{
                let data:IClienteSimple[] = res?.data ?? [];
                data = data.map((c)=>{
                    let coordenadas = undefined;
                    if(c.coordenadas && c.coordenadas.indexOf(",") !== -1){
                        let latLng = c.coordenadas.split(",");
                        coordenadas = {
                            lat: parseFloat(latLng[0]),
                            lng: parseFloat(latLng[1]),
                        };
                    }

                    return {...c,coordenadasObj: coordenadas}

                })
                setClientes(data)
            })
    },[setClientes,setAllAgents,setAgentsCoor])
    useEffect(()=>{
        if(!center?.lat){
            if(clientes.length){
                setCenter(clientes.find(e=>!!e.coordenadasObj)?.coordenadasObj ?? null);
            }else{
                navigator.geolocation.getCurrentPosition(({coords})=>{
                    setCenter({lat: coords.latitude, lng: coords.longitude})
                    setCurrentPoint({lat: coords.latitude, lng: coords.longitude})
                }, (err)=>{
                    console.log(err)
                }, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            }
        }

    },[center,clientes,setCurrentPoint, setCenter])
    const handleFilterChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {value} = e.target
        let filtro = clientes.filter((c)=>noTilde(c.nombre).indexOf(noTilde(value)) !== -1);
        return setClientesFilter(filtro.slice(0,20));
    }
    const showClientModal = (id:number) => {
        dispatch(mostrarClienteById(id));
        navigate(location.pathname, {state: {cliente:{id}}});
    };



    return isLoaded ? <>
        <AppBar />
        <section className="contentInner">


            <ListViewMode  noView>
                <ButtonResponsive icon={<Help/>} text={Strings.ayuda} onClick={() => window.open("https://youtu.be/82YgTriT5So","_blank")}/>
                <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(!openFilter)}/>
            </ListViewMode>

            <GoogleMap
                mapContainerStyle={{
                    width: '100%',
                    height: `calc(100vh - ${smVewport ? "90" : "101"}px)`
                }}
                center={center || initialCenter}
                zoom={13}
                // onLoad={onLoad}
                // onUnmount={onUnmount}
            >
                {clientes?.filter(e=> !!e.coordenadasObj).map(c =>
                    <Marker
                        key={c.id}
                        position={{
                            lat: c.coordenadasObj?.lat ?? 0,
                            lng: c.coordenadasObj?.lng ?? 0
                        }}
                        title={c.nombre}
                        onClick={()=>setInfoWin(infoWin === "cli-"+c.id ? null: "cli-"+c.id!)}
                        animation={infoWin === "cli-"+c.id && (window as any).google.maps.Animation.ep}
                        icon={pinSymbol(c.rutaColor,c.rutaIcon)}
                    >
                        {(infoWin === "cli-"+c.id || infoWin === "all") &&
                        <InfoWindow onCloseClick={()=>setInfoWin(null)}>
                            <div onClick={()=>showClientModal(c.id!)}>
                                <Typography>{c.nombre}</Typography>
                                <Typography color={"primary"} variant={"body2"}>Mas información</Typography>
                            </div>
                        </InfoWindow>}
                    </Marker>
                )}
                  {currentPoint &&
                    <Marker
                        position={currentPoint}
                        title={"Yo"}
                        onClick={()=>setInfoWin(infoWin === "me" ? null: "me")}
                        label={"Yo"}
                       // icon={pinSymbol("#e83527","Navigation")}

                    >
                        {(infoWin === "me" || infoWin === "all") &&
                        <InfoWindow onCloseClick={()=>setInfoWin(null)}>
                            <>
                                <Typography color={"primary"}>{Strings.ubicacionActual}</Typography>
                                <p>{Strings.ubicacionActualMjs}</p>
                            </>
                        </InfoWindow>}
                    </Marker>
                }
                {agentsCoor?.map((ag)=>
                    <Marker
                        key={ag.id}
                        position={{
                            lat: ag.coordenadasObj?.lat ?? 0,
                            lng: ag.coordenadasObj?.lng ?? 0
                        }}
                        title={ag.inicioSesion}
                        onClick={()=>setInfoWin(infoWin === "age-"+ag.id ? null: "age-"+ag.id!)}
                        //icon={pinSymbol(ag.rutaColor,"motorbike")}

                    >
                        {(infoWin === "age-"+ag.id || infoWin === "all") &&
                        <InfoWindow onCloseClick={()=>setInfoWin(null)}>
                            <>
                                <Typography color={"primary"}>{ag.inicioSesion}</Typography>
                                <p>{ag.nombre}</p>
                            </>
                        </InfoWindow>}
                    </Marker>
                )}
            </GoogleMap>
            <Backdrop className={classes.backdrop} open={openFilter} onClick={()=>setOpenFilter(false)}>

                <div className={classes.searchBox} onClick={(e)=>e.stopPropagation()}>
                    <div onClick={(e)=>e.stopPropagation()}>
                        <input type="text" onChange={handleFilterChange}
                               placeholder={Strings.buscar} autoFocus/>
                    </div>
                    <List>
                        {clientesFilter?.map(c =><Fragment key={c.id}>
                            <ListItemButton onClick={()=>{
                                if(c.coordenadasObj){
                                    setInfoWin("cli-"+c.id!);
                                    setCenter(c.coordenadasObj);
                                    setOpenFilter(false)
                                }else{
                                    setSnackbar(Strings.noMapMjs)
                                }
                            }} >
                                <ListItemText>
                                    <Typography noWrap>
                                        {c.nombre}
                                    </Typography>
                                </ListItemText>
                            </ListItemButton>
                            <Divider component="li" />
                        </Fragment>)}
                        <ListItem>
                            <ListItemText>
                                <Typography color={"primary"} variant={"body2"} noWrap>
                                    {Strings.agentes}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        {allAgents?.map(a =>
                            <Fragment key={a.id}>
                                <ListItemButton onClick={()=>{
                                    if(a?.coordenadasObj){
                                        setInfoWin("age-"+a.id!);
                                        setCenter(a.coordenadasObj);
                                        setOpenFilter(false)
                                    }else{
                                        setSnackbar(Strings.noMapMjs)
                                    }
                                }}>
                                    <ListItemText>
                                        <Typography noWrap>
                                            {a.nombre}
                                        </Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <Divider component="li" />
                            </Fragment>)}
                    </List>
                </div>
            </Backdrop>
            <ContactDetails />
            <Snackbar open={!!snackbar} autoHideDuration={2000}
                      anchorOrigin={{ vertical:'top', horizontal:'center' }}
                      onClose={()=>setSnackbar(null)}>
                <Alert severity="warning">
                    {snackbar}
                </Alert>
            </Snackbar>
        </section>

    </> :<></>
}

export default Map
